import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import QRCode from 'qrcode.react';
import { ISitePosterPageRouteParams } from './types';
import { useAuthentication } from '../../../authentiction';
import { Helmet } from 'react-helmet';
import {
  ViewPort,
  Poster,
  Header,
  Heading,
  Body,
  SubHeading,
  Instructions,
  ManualLink,
  Footer,
  ButtonContainer,
} from './SitePosterPage.styled';
import { Button } from 'react-bootstrap';

const SitePosterPage: React.FC = () => {
  const { pin } = useParams<ISitePosterPageRouteParams>();
  const history = useHistory();
  const { site } = useAuthentication();

  useEffect(() => {
    window.print();
  }, []);

  return (
    <ViewPort>
      <Poster>
        <Helmet>
          <body className="bg-white" />
        </Helmet>
        <Header>
          <Heading>{site}</Heading>
        </Header>
        <Body>
          <SubHeading>
            Scan the QR Code below to sign in or out using your smart phone
          </SubHeading>
          <Instructions>
            Please make sure that you are connected to the internet and follow
            the link provided
          </Instructions>
          <QRCode
            value={`${window.origin}/visitor/site/${pin}/signIn`}
            level={'L'}
            renderAs={'svg'}
            size={512}
          />
          <ManualLink>
            Alternatively go to {`${window.origin}/visitor/site/${pin}/signIn`}
          </ManualLink>
        </Body>
        <Footer>
          <ButtonContainer>
            <Button
              type="button"
              variant="secondary"
              onClick={() => history.push('/admin/sites')}
            >
              Back to list
            </Button>
            <Button
              type="button"
              variant="primary"
              onClick={() => window.print()}
            >
              Print
            </Button>
          </ButtonContainer>
        </Footer>
      </Poster>
    </ViewPort>
  );
};

export default SitePosterPage;
